import { render, staticRenderFns } from "./referrals-histogram-card.vue?vue&type=template&id=83e51360&scoped=true&"
import script from "./referrals-histogram-card.vue?vue&type=script&lang=js&"
export * from "./referrals-histogram-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e51360",
  null
  
)

export default component.exports